export default {
  nav: {
    Home: "首頁",
    Profile: "個人檔案",
    Project: "專案",
    Resume: "履歷",
    Blog: "部落格",
  },
  common: {
    ghost: "幽靈嚮導",
    self: "???",
    openSidebar: "開啟側邊欄",
    lightMode: "淺色模式",
    darkMode: "深色模式",
    switchToZh: "中文",
    switchToEn: "EN",
    open: "開啟 →",
    goToProject: "前往專案 {n}",
  },
  search: {
    placeholder: "搜尋這片森林…",
    loading: "正在從森林中收集記憶…",
    noResults: '森林中沒有關於「{query}」的動靜',
    categories: {
      Page: "頁面",
      Profile: "個人檔案",
      Blog: "部落格",
      Project: "專案",
      Resume: "履歷",
    },
  },
  chat: {
    subtitle: "森林中的幽靈 · AI 嚮導",
    clearChat: "清除對話",
    placeholder: "悄悄問一個問題…",
    openChat: "開啟 AI 對話",
    welcome:
      "…你好？我是這片森林裡的幽靈。訪客會告訴我故事。問問我還記得什麼…",
    cleared: "…記憶如霧般消散。你想知道什麼？",
    error:
      "…森林吞沒了我的思緒。API 的靈魂安靜了。請稍後再試。",
  },
  home: {
    welcome: "啊，又一位客人。歡迎！來火堆旁坐坐吧。",
    cards: {
      profile: { title: "你…你是誰？", link: "[前往個人檔案]" },
      project: { title: "你在這裡做什麼？", link: "[前往專案]" },
      resume: { title: "你為什麼在這裡？", link: "[前往履歷]" },
      blog: { title: "告訴我你記得什麼？", link: "[前往部落格]" },
    },
  },
  profile: {
    cards: {
      introduction: "自我介紹",
      education: "學歷",
      skills: "技能",
      workExperience: "工作經歷",
    },
    introduction: {
      tagline: "- 他們說跳，你說跳多高 -",
    },
    education: {
      title: "學歷",
    },
    skills: {
      title: "目前技術",
      groups: {
        Frontend: "前端",
        Backend: "後端",
        Infrastructure: "基礎設施",
        Development: "開發流程",
        Others: "其他",
      },
    },
    workExperience: {
      title: "工作經歷",
    },
    dialogs: {
      default: [
        "我已經很久沒跟別人說話了…",
        "這片森林很孤獨",
        "也許你可以到處看看，幫我找一些關於自己的線索？",
        "來這裡的訪客會告訴我外面的世界的故事",
        "而我會用關於自己的故事回報他們…",
        "但我記不起太多關於自己的事",
        "所以我只能重複一些我聽過的故事",
      ],
      introduction: [
        "（看著名牌）我…在迷失於這片森林之前是個開發者",
        "…但我不記得其他事了…",
        "不要在這裡待太久，否則你也可能忘記自己是誰",
      ],
      education: [
        "大學？我想我去過一所…",
        "我聽說大學就像…很大的學校？",
        "我想我讀的是電腦工程？但我不記得那是什麼…",
      ],
      skills: [
        "技能？我想我有一些…",
        "有人曾說我擅長網頁開發？",
        "雲端服務？我想我也有一些經驗…",
      ],
      workExperience: [
        "工作經歷？我想我也有一些…",
        "我記得…一個辦公室？我想我以前在辦公室工作過？",
        "但我不記得我們在那裡做什麼…森林讓我忘記得太快了…",
      ],
    },
  },
  project: {
    speech: "有人把電話留在這裡，我用它做了一些東西…",
    title: "我做的東西",
  },
  resume: {
    speech: "我不知道自己為什麼在這裡，但醒來時發現身邊有這張紙…",
    title: "履歷",
    pdfTitle: "履歷 PDF",
    handAlt: "握筆的手",
  },
  blog: {
    title: "部落格",
    loading: "載入部落格文章…",
    error: "載入部落格文章失敗",
    toc: "文章目錄",
    readSingle: "單篇閱讀 →",
    backToAll: "返回全部文章",
    postNotFound: "這段記憶已從森林中消散。",
  },
  notFound: {
    title: "迷失森林",
    message: "你走的路通向虛無。連幽靈也找不到這個頁面。",
    backHome: "回到營火旁",
  },
  site: {
    profile: {
      name: "Alice Lee",
      username: "xfdxfdxfd",
      tagline: "他們說跳，你說跳多高",
    },
    education: {
      institution: "香港大學",
      years: "2021-2025",
      degree: "工程學士（電腦工程）",
    },
    skills: {
      Frontend: ["Vue.js", "Tailwind CSS", "BootStrap"],
      Backend: [
        "Python",
        "Django",
        "Express.js",
        "PostgreSQL",
        "SQLite",
        "RESTful API",
        "Node.js",
        "Kafka",
      ],
      Infrastructure: [
        "CloudFlare",
        "阿里雲 ECS",
        "Docker",
        "Google Cloud",
        "Ubuntu",
      ],
      Development: ["UML 圖", "敏捷開發", "SDLC", "Jira"],
      Others: ["Unity", "數位繪圖", "Github Copilot", "Cursor"],
    },
    workExperience: [
      {
        title: "Tomorrow's Brain（語言、言語及閱讀實驗室）",
        position: "程式設計師",
        duration: "2025.07 – 至今",
        description: [
          "在一個月內獨立建立集中式 Django OAuth 伺服器及全端 Stripe 付款系統，運用 AI 工具將產品發布日期提前 30 天。",
          "在阿里雲 ECS 上部署 4 項服務，配備自動快照及主動警報，確保超過 95% 正常運行時間且零資料遺失。",
          "設計高效能自然語言生成演算法，將報告處理時間縮短至 5 秒以內（涵蓋 5 個以上領域）。",
          "獨立建立並部署集中式 Kafka 驅動的電郵微服務，實現 5 秒內送達及可自訂 CSS。",
        ],
      },
      {
        title: "語言、言語及閱讀實驗室",
        position: "兼職及實習研究助理",
        duration: "2023.07 – 2025.06",
        description: [
          "將後端架構從屬性鏈結重構為唯一 ID 查詢，縮窄 API 範圍，將查詢時間從 30 秒縮短至 5 秒以內。",
          "實作 IndexedDB 客戶端快取，防止意外離開頁面時媒體遺失，將事故頻率從每週降至每月 1–2 次。",
          "設計並排程實驗室實體伺服器的每日及每週自動備份工作流程，保障關鍵研究資料免受硬體故障影響。",
        ],
      },
    ],
    projects: [
      {
        title: "Dante Dog LCB",
        category: "網頁開發",
        blurb: "在地品牌全端網站平台 — Django 後端、現代化前端與正式環境部署。",
      },
      {
        title: "VR Bang Dream!",
        category: "VR",
        blurb: "BanG Dream! 風格的 Unity VR 節奏遊戲 — 為沉浸式頭戴裝置打造手勢操作玩法。",
      },
      {
        title: "IntelliTrack",
        category: "網頁開發、AI",
        blurb: "AI 輔助追蹤網頁應用 — 智慧分類與儀表板，部署於 Cloudflare Pages。",
      },
    ],
    navPages: [
      {
        name: "Home",
        description: "歡迎頁面 — 幽靈在森林火堆旁迎接訪客",
      },
      {
        name: "Profile",
        description: "Alice Lee 的自我介紹、學歷、技能及工作經歷",
      },
      {
        name: "Project",
        description:
          "Alice 的專案 — Dante Dog LCB、VR Bang Dream!、IntelliTrack",
      },
      {
        name: "Resume",
        description: "Alice Lee 的履歷 PDF",
      },
      {
        name: "Blog",
        description: "關於 Unity、Vue Router、Docker 等的技術部落格",
      },
    ],
    cvSummary:
      "Alice Lee (xfdxfdxfd) — 香港大學電腦工程學士（2021-2025）。全端開發者，精通 Vue.js、Python/Django、雲端基礎設施（阿里雲、Docker、CloudFlare）。現任 Tomorrow's Brain（語言、言語及閱讀實驗室）程式設計師。曾任語言、言語及閱讀實驗室研究助理。完整履歷見 /CV-LeeSinWing.pdf。",
    search: {
      introTitle: "{name} — 自我介紹",
      educationTitle: "學歷",
      skillsTitle: "技能與技術",
      resumeTitle: "履歷 / CV",
    },
  },
};
